import channelsUtil from '../../../helpers/channelsUtil';
import { getItemProperties } from '../../../contexts/MixpanelHelper';
import h from '../../../helpers/common';
import { EVENT } from '../../../contexts/MixpanelConstants';

export const handleMixpanelEvents = (item, track, userChannels) => {
    if (!item) return;

    const { stationId, promoType, programType, title, programTitle, textEn } = item;
    const channel = channelsUtil.getChannelByStationId(stationId, userChannels);

    const carouselItemName = title ?? programTitle?.en;
    const carouselType = promoType ?? programType;

    // Extract channel category if available
    const channelCategory = Array.isArray(channel?.category) && channel.category[0] ? channel.category[0] : undefined;

    track(EVENT.CATCHUP.CAROUSEL_ITEM_CLICK, {
        'Screen Name': h.getScreen(),
        'Carousel Name': name,
        'Carousel Type': carouselType,
        'Item Name': carouselItemName,
        ...getItemProperties({
            ...item,
            title: textEn ?? title,
            name: textEn ?? title,
            ...channel,
            ...(channelCategory && { channelCategory }),
        }),
    });
};

export const sendMixpanelClickEvent = (track) => {
    track(EVENT.CAROUSEL.ITEM_CLICK, {
        'Screen Name': h.getScreen(),
    });
};
